type GeneralInfoSectionProps = {
  icon: React.ReactNode
  title: string
  subtitle?: string
  text?: string
}

const GeneralInfoSection = ({ icon, title, subtitle, text }: GeneralInfoSectionProps) => {
  return (
    <div className="flex flex-row items-start gap-3">
      <div className="w-[30px] lg:w-[35px]">{icon}</div>
      <div className="flex flex-col items-start justify-start">
        <div className="flex flex-row items-center gap-2">
          <p className="text-base font-semibold text-primary lg:text-[17px]">{title}</p>
          {subtitle && <p className="text-[13px] font-semibold text-muted lg:text-sm">{subtitle}</p>}
        </div>
        {text && <p className="text-[13px] text-muted lg:text-sm">{text}</p>}
      </div>
    </div>
  )
}

export default GeneralInfoSection
